import { inject, Injectable, Injector } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { TokenService } from './token.service';
import { Router } from '@angular/router';
import { ApiService } from '@aeCore/services/api.service';

@Injectable({ providedIn: 'root' })
export class AuthService extends ApiService {
  private tokenService = inject(TokenService);
  private router = inject(Router);

  constructor(protected override injector: Injector) {
    super(injector);
  }

  login(credentials: {
    email: string;
    password: string;
  }): Observable<{ accessToken: string; refreshToken: string }> {
    return this.post<{ accessToken: string; refreshToken: string }>(
      ['auth', 'login'],
      credentials,
    ).pipe(
      tap({
        next: (tokens) =>
          this.tokenService.saveTokens(tokens.accessToken, tokens.refreshToken),
        error: (error) => {
          this.tokenService.removeTokens();
          throw error;
        },
      }),
    );
  }

  logout(): void {
    this.post(['auth', 'logout'], {
      refreshToken: this.tokenService.getRefreshToken(),
    }).subscribe({
      complete: () => {
        this.tokenService.removeTokens();
        this.removeAuthData();
        this.router.navigate(['/auth']);
      },
      error: () => {
        this.tokenService.removeTokens();
        this.removeAuthData();
        this.router.navigate(['/auth']);
      },
    });
  }

  isAuthenticated(): boolean {
    return !this.tokenService.isAccessTokenExpired();
  }

  resetPassword(body: { email: string }): Observable<boolean> {
    return this.post<boolean>(['admin', 'users', 'forgot'], body);
  }

  removeAuthData() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('tfaCompleted');
    localStorage.removeItem('nav_items');
  }
}
